import { FormControl, Grid, IconButton, InputAdornment, Paper, TextField } from "@mui/material";
import { GroupingTable } from "../../../components/Table/grouping_table";
import { Search, SearchOutlined } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ThemeContext } from "@emotion/react";
import moment from "moment";
import { useLoading } from "../../../components/Loading/useLoading";
import { TipoDocumentoEnum } from "../../../@enums/tipo_documento";
import { GetOrdenesNew } from "../../../hooks/getOrdenes";
import { EstatusDocumentoEnum } from "../../../@enums/status_documento.enum";

export const TablaSalidaInventario = ({ getSend, setGetSend, handleFilterChange }) => {
  const theme = useContext(ThemeContext);
  const navigate = useNavigate();
  const { setAppLoading } = useLoading();

  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState({
    filter: searchParams.get('filter') ?? "",
    start: searchParams.get('start') ?? null,
    end: searchParams.get('end') ?? null,
  });

  const { getOrdenesNewMutation } = GetOrdenesNew();
  const [rows, setRows] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [inicio, setInicio] = useState(moment().format('YYYY-MM-DD'));
  const [end, setEnd] = useState(moment().format('YYYY-MM-DD'));
  const sort = {}

  const columns = [
    {
      accessorKey: 'docu_folio',
      header: 'Folio',
    },
    {
      accessorFn: (row) => moment(row?.docu_fecharegistro, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY") || '',
      id: 'fecha',
      header: 'Fecha',
      sortingFn: 'text',
      filterFn: 'includesString',
    },
    {
      accessorFn: (row) => moment(row?.docu_fecha, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY") || '',
      id: 'fecha_cierre',
      header: 'Fecha cierre',
      sortingFn: 'text',
      filterFn: 'includesString',
    },
    {
      accessorFn: (row) => JSON.parse(row?.docu_extradata).almacen || '',
      id: 'almacen',
      header: 'Almacen',
      sortingFn: 'text',
      filterFn: 'includesString',
    },
  ];
  const redirect = (row) => {
    if (row) {
      navigate(`/inventarios/ajuste-inventario/${row?.docu_id}/${JSON.parse(row?.docu_extradata).alma_id}`);
    }
  }

  //Search
  const handleInputChange = (event) => {
    setFiltro(event.target.value);
  };
  const handleKeyDown = (event) => {
    get_ordenes_enviadas(filtro, inicio, end);
  };

  const get_ordenes_enviadas = (clave, fecha_inicial, fecha_final) => {
    let where = {
      docu_tipo: TipoDocumentoEnum.SALIDA_ALMACEN,
      docu_estatus: EstatusDocumentoEnum.CERRADO,
    };
    setAppLoading(true);
    handleFilterChange('filter', filtro);
    handleFilterChange('start', inicio);
    handleFilterChange('end', end);
    getOrdenesNewMutation(
      { where: where, relations: {}, clave, fecha_inicial, fecha_final },
      {
        onSuccess: (data) => {
          setRows(data);
          setAppLoading(false)
        },
        onError: (error) => {
          console.log(error);
          setAppLoading(false);
        },
      }
    );
  };

  useEffect(() => {
    if (getSend) {
      setRows([]);
      setGetSend(false);
    }
    if (searchTerm.filter || searchTerm.start || searchTerm.end) {
      setFiltro(searchTerm.filter ?? '');
      setInicio(searchTerm.start ?? null);
      setEnd(searchTerm.end ?? null);
      get_ordenes_enviadas(searchTerm.filter, searchTerm.start, searchTerm.end);
    }
  }, [getSend]);

  return (
    <Paper style={{ height: '100%', width: '100%' }} sx={{ boxShadow: 'none' }}>
      <Grid container spacing={0}>
        <Grid item xs={12} sx={{ p: 1, justifyContent: 'flex-end', flexDirection: 'row', gap: 2 }} className="center_item">
          <TextField
            id="search_entry"
            label="Ingrese palabra clave"
            name="search_entry"
            size="small"
            value={filtro}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{ color: theme.palette.primary.input }}
          />
          <FormControl variant="outlined" >
            <TextField
              id='filtro_start'
              type="date"
              size="small"
              value={inicio}
              label='Inicio'
              name="filtro_start"
              hiddenLabel
              placeholder=""
              sx={{ color: theme.palette.primary.input }}
              onChange={(e) => setInicio(e.target.value)}
              className="input-date_salida"
              InputLabelProps={{
                shrink: true,
              }}

            />
          </FormControl>
          <FormControl variant="outlined" >
            <TextField
              id='filtro_end'
              type="date"
              size="small"
              value={end}
              label='Fin'
              name="filtro_end"
              hiddenLabel
              placeholder=""
              sx={{ color: theme.palette.primary.input }}
              onChange={(e) => setEnd(e.target.value)}
              className="input-date_salida"
              InputLabelProps={{
                shrink: true,
              }}

            />
          </FormControl>
          <IconButton
            variant="contained"
            sx={{
              p: 1,
              backgroundColor: '#575E3B',
              borderRadius: 2,
              color: 'white',
            }}
            onClick={handleKeyDown}>
            <SearchOutlined />
          </IconButton>
        </Grid>
      </Grid>
      <GroupingTable
        key='tabla_salida_inventario'
        columnas={columns}
        data={rows}
        redirect={redirect}
        sort={sort}
      />
    </Paper>
  )
}